import gql from 'graphql-tag';

export const collaboratingUserEnteredSurfaceSubscription = gql`
  subscription collaboratingUserEnteredSurface($surface: ID!, $user: ID!) {
    collaboratingUserEnteredSurfaceSubscription(
      surface: $surface
      user: $user
    ) {
      user {
        id
        email
        fullName
      }
      cursorPosition {
        x
        y
      }
      color
      surface
    }
  }
`;
